<template>
  <div>
    <!---------------- 顶部 ---------------->
    <el-row :gutter="20" class="mt20" >
      <!-- 终端用户数量 -->
      <el-col :sm="12" :md="12" :lg="6" :xl="6">
        <div class="bgw numShow">
          <div class="numShow_l"><img src="../assets/images/icon1.jpg" alt=""></div>
          <div class="numShow_r">
            <h2 class="green">{{numTerminalUser}}</h2>
            <h3>终端用户数量</h3>
          </div>
        </div>
      </el-col>
      <!-- 终端用户数量 End -->

      <!-- 设备数量 -->
      <el-col :sm="12" :md="12" :lg="7" :xl="7">
        <div class="bgw numShow">
          <div class="numShow_l"><img src="../assets/images/icon2.jpg" alt=""></div>
          <div class="numShow_r">
            <h2 class="orange">{{numDevice}}</h2>
            <h3>设备数量</h3>
          </div>
        </div>
      </el-col>
      <!-- 设备数量 End -->

    </el-row>
    <!---------------- 顶部 End ---------------->

    <!-- 中部 -->
    <el-row :gutter="20" class="mt20">
      <!-- 动作库数量 -->
      <el-col :sm="12" :md="12" :lg="6" :xl="6">
        <div class="bgw numShow">
          <div class="numShow_l"><img src="../assets/images/icon3.jpg" alt=""></div>
          <div class="numShow_r">
            <h2 class="green">{{numAction}}</h2>
            <h3>动作库数量</h3>
          </div>
        </div>
      </el-col>
      <!-- 动作库数量 End -->

      <!-- 课程数量 -->
      <el-col :sm="12" :md="12" :lg="7" :xl="7">
        <div class="bgw numShow">
          <div class="numShow_l"><img src="../assets/images/icon4.jpg" alt=""></div>
          <div class="numShow_r">
            <h2 class="orange">{{numCourse}}</h2>
            <h3>课程数量</h3>
          </div>
        </div>
      </el-col>
      <!-- 课程数量 End -->

      <!-- 训练计划数量 -->
      <el-col :sm="12" :md="12" :lg="7" :xl="7">
        <div class="bgw numShow">
          <div class="numShow_l"><img src="../assets/images/icon5.jpg" alt=""></div>
          <div class="numShow_r">
            <h2 class="orange">{{numTrainPlan}}</h2>
            <h3>训练计划数量</h3>
          </div>
        </div>
      </el-col>
      <!-- 训练计划数量 End -->
    </el-row>
    <!-- 中部 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import * as echarts from 'echarts'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      numTerminalUser: '0',
      numDevice: '0',
      numAction: '0',
      numCourse: '0',
      numTrainPlan: '0'
    }
  },
  mounted () {
    this.HomeGet()
  },
  methods: {
    HomeGet: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_HomeGet, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            console.log(response.data.data)
            that.numTerminalUser = response.data.data.numTerminalUser
            that.numDevice = response.data.data.numDevice
            that.numAction = response.data.data.numAction
            that.numCourse = response.data.data.numCourse
            that.numTrainPlan = response.data.data.numTrainPlan
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
  }
}
</script>

<style lang="less" scoped>
.numShow {
  display: flex;
  align-items: center;
  cursor: pointer;

  .numShow_r{
    flex: 1;
    padding-top: 6px;

    h3 {
      font-size: 16px;
      color: #000;
    }
    h4 {
      font-size: 14px;
      font-weight: normal;
      color: #999;
    }
    .green{
      color: #48c184;
    }
    .orange{
      color: #f68059;
    }
    .yellow{
      color: #e9ab2a;
    }
  }
}

.numShow_l{
  width: 100px;
  margin-right: 24px;
}

.numShow_r h2 {
  font-size: 30px;
}

.four {
  padding: 15px 10px;
  text-align: center;
  background: #f7f7f7;
  border-radius: 6px;

  h4 {
    color: #000;
    font-size: 24px;
  }
}

.four p{
  margin: 0;
  padding-top: 5px;
  color: #666;
  font-size: 13px;
}

@media ( min-width: 2000px) {
  .four {
    padding: 25px 10px 25px 10px;
    text-align: center;
    background: #f7f7f7;
    border-radius: 6px;

    h4 {
      color: #000;
      font-size: 24px;
    }

    p {
      margin: 0;
      padding-top: 5px;
      color: #666;
    }
  }
}

@media ( max-width: 1400px) {
  .numShow_l{
    margin-right: 8px;
  }

  .numShow_r h2{
    font-size: 24px;
  }

  .four {
    h4 {
      color: #000;
      font-size: 18px;
    }
  }

  .four p{
    font-size: 12px;
  }
}

.power {
  text-align: center;
  h2 {
    font-size: 16px;
    color: #000;
    font-weight: normal;
    padding-top: 15px;
  }
}

.map{
  margin-top: 15px;
  height: 680px;
  background: #f6f6fa;
}

// 选择项目弹框结构
.add_body{
  position: relative;

  .project_search{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 42px;
    padding: 0px 20px 0px 20px;
    overflow: hidden;
    z-index: 10;
  }

  .clearTop{
    height: 58px;
  }

  .project_data{
    height: 280px;
    margin: 0px 20px 0 20px;
    overflow-y: scroll;

    &::-webkit-scrollbar{
      width: 6px;  /*滚动条宽度*/
      height: 6px;  /*滚动条高度*/
    }

    /*定义滑块 内阴影+圆角*/
    &::-webkit-scrollbar-thumb{
      border-radius: 3px;
      background-color: #4976ff;  /*滚动条的背景颜色*/
    }
  }
}

// 按钮
/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 弹出框
.edit /deep/ .dialog-footer {
  padding: 20px 0px 20px 0px;
  display: block;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.edit /deep/ .el-dialog__footer {
    padding:0px;
}

.edit /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}

.edit /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.edit /deep/ .el-dialog__body {
  padding: 20px 0px 0px 0px;
}

// 表格头部背景色
/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}

/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}

.confirmDel{
  /deep/ .el-dialog__body {
    padding: 20px;
  }

  /deep/ .el-dialog__header {
    padding: 15px 20px 15px;
    background: #f6f6fa;
  }
}

// 2021.07.21
.choseProject{
  /deep/ .btnPanel.el-button{
    border-radius:0 20px 20px 0;
    padding: 10px 25px;
  }

  .panel{
    position: relative;
    background: #fff;
    border-radius: 10px 0 10px 10px;
    min-height: 200px;
    margin-right: 30px;
    padding: 20px;
  }
  .panel .close{
    position: absolute;
    top: 0;
    right: -30px;
    height: 40px;
    width: 30px;
    line-height: 40px;
    font-size: 16px;
    color: #c8c8c8;
    text-align: center;
    border-radius: 0 20px 20px 0;
    background: #fff;
    cursor: pointer;
  }
  .back{
    position: absolute;
    top: 20px;
    right: 20px;
    color: #2c6eff;
    border: 1px solid #2c6eff;
    background: #e1ebff;
  }
}

.total_power{
  display: flex;

  .total_power_l{
    width: 100px;
    margin-right: 20px;
  }
  .total_power_r{
    flex: 1;

    h4 {
      font-size: 14px;
      color: #000;
      text-align: center;
    }
  }
}

.total_power_m{
  width: 170px;
  margin-right: 0px;
  margin-top: 12px;

  h2 {
    color: #f6805a;
    font-size: 30px;
  }
  h3 {
    font-size: 16px;
    color: #000;
  }
  h4 {
    font-size: 14px;
    font-weight: normal;
    color: #999;
  }
}

@media ( max-width: 1400px) {
  .total_power_m{
    width: 150px;
    margin-right: 10px;

    h2 {
      color: #f6805a;
      font-size: 24px;
      padding-top: 17px;
    }
  }
}

/deep/ .cell {
  cursor: default;
}
</style>
